const configuredSiteUrl = process.env.REACT_APP_SITE_URL;

export const SITE_URL = (
  configuredSiteUrl || window.location.origin
).replace(/\/$/, "");
